import { useEffect } from "react";
import { autoLogout } from "../..//store/actions/auth";
import { useDispatch, useSelector } from "react-redux";

const useAutoLogout = (inactivityLimit = 1 * 60 * 1000) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const updateActivity = () => {
    if (user === null) return;
    const currentPathname = window.location.pathname;
    const lastPathname = sessionStorage.getItem("currentPathname");
    if (currentPathname !== lastPathname) {
      if (
        (lastPathname?.startsWith("/viewshipment") &&
        currentPathname === "/shipments")
      ) {
      } else {
        sessionStorage.setItem("currentPathname", currentPathname);
      }
    }

    localStorage.setItem("lasActivity", Date.now().toString());
  };

  useEffect(() => {
    const events = [
      "mousemove",
      "keydown",
      "mousemove",
      "popstate",
      "mousedown",
      "touchstart",
    ];

    events.forEach((event) => {
      window.addEventListener(event, updateActivity);
    });

    updateActivity();

    const interval = setInterval(() => {
      const lastActivity = localStorage.getItem("lasActivity");
      const now = Date.now();

      if (lastActivity && now - parseInt(lastActivity) > inactivityLimit) {
        dispatch(autoLogout(true));
      }
    }, 10000);

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, updateActivity);
      });
      clearInterval(interval);
    };
  }, [user]);
};

export default useAutoLogout;
